
import Biblioteca from '../../images/img-description.jpg';

export const headerInfo = {
  title: "Biblioteca de Ciencias Sociales",
  description: (
    <>
      <p>
        La Biblioteca de Ciencias Sociales, el más antiguo de los tres acervos
        de CIRMA, inició en 1978 con la unión de las bibliotecas personales de
        algunos de sus fundadores. Hoy en día cuenta con una destacada colección
        enfocada en la región mesoamericana que incluye más de 100,000 títulos,
        8,000 documentos, una extensa gama de revistas y un acogedor salón de
        lectura.
      </p>
      <p>
        Además, se enorgullece de resguardar dos fondos de colecciones
        especiales: la colección personal de Franz Termer y la colección de
        Libros Antiguos, auténticas joyas bibliográficas que abarcan desde
        principios del siglo XVII hasta mediados del XIX.
      </p>
    </>
  ),
  image: Biblioteca,
};
